import { post, get } from '../http/axios';

//重新发起AI检查
export const callAiCheck = (payload, appConfig) => {
  // let payload = { "code": "1234", "name": "yyyy" };
  return post(
    appConfig.servers.apiServer[0].baseUrl + 'yinghe-api/viewer/callAiCheck',
    payload
  ).catch(err => {
    console.log(err);
    return err;
  });
};

// 2. 获取用户信息
export const getStudyLis2t = (filter, size, current, order = {}, appConfig) => {
  let url =
    appConfig.servers.apiServer[0].baseUrl + 'yinghe-api/viewer/getCheckList';
  let search = [];
  let searchkey = [
    { searchKey: 'userName', searchValue: [] },
    { searchKey: 'device', searchValue: [] },
    { searchKey: 'checkName', searchValue: [] },
  ];
  if (filter) {
    if (Array.isArray(filter)) {
      for (let i = 0; i < filter.length; i++) {
        if (!filter[i].pid) {
          search.push(filter[i].value);
        }
        if (filter[i].pid === 1) {
          searchkey[0].searchValue.push(filter[i].value);
        }
        if (filter[i].pid === 2) {
          searchkey[1].searchValue.push(filter[i].value);
        }
        if (filter[i].pid === 3) {
          searchkey[2].searchValue.push(filter[i].value);
        }
      }
    } else {
      search.push(filter);
    }
  } else {
    url =
      appConfig.servers.apiServer[0].baseUrl + 'yinghe-api/viewer/getCheckList';
    search = [];
    searchkey = [
      { searchKey: 'userName', searchValue: [] },
      { searchKey: 'device', searchValue: [] },
      { searchKey: 'checkName', searchValue: [] },
    ];
  }

  if (search.length > 0) {
    return post(url, {
      ...order,
      search: search,
      searchKeyAndValue: searchkey,
      current: current + 1,
      size: size,
    }).catch(err => {
      console.log(err);
      return err;
    });
  } else {
    return post(url, {
      ...order,
      searchKeyAndValue: searchkey,
      current: current + 1,
      size: size,
    }).catch(err => {
      console.log(err);
      return err;
    });
  }
};

// 3. 获得搜索条件值列表
export const getValueListBySearch = (value, appConfig) => {
  let url =
    appConfig.servers.apiServer[0].baseUrl +
    `yinghe-api/viewer/getValueListBySearch?searchKey=${value}`;
  return get(url).catch(err => {
    console.log(err);
    return err;
  });
};
export const getAnalysisResultList = payload => {
  return post('yinghe-api/viewer/getAiResultById', payload).catch(err => {
    console.log(err);
    return err;
  });
};

export const confirmAiResult = payload => {
  return post('yinghe-api/viewer/confirmAiResult', payload).catch(err => {
    console.log(err);
    return err;
  });
};

export const saveAiCheck = payload => {
  // let payload = { "code": "1234", "name": "yyyy" };
  return post('yinghe-api/viewer/saveAiCheck', payload).catch(err => {
    console.log(err);
    return err;
  });
};

export const saveAiCheckedItem = payload => {
  // let payload = { "code": "1234", "name": "yyyy" };
  return post('yinghe-api/viewer/saveAiCheckedItem', payload).catch(err => {
    console.log(err);
    return err;
  });
};

export const getAiResultSearchById = payload => {
  return get(
    `yinghe-api/viewer/getAiResultSearchById?aiCheckId=${payload.aiCheckId}&aiInfoId=${payload.aiInfoId}&searchKey=${payload.searchKey}`
  ).catch(err => {
    console.log(err);
    return err;
  });
};

export const colourOptions = [
  { value: 'userName', label: '姓名', rid: 1, pid: 0 },
  { value: 'device', label: '设备', rid: 2, pid: 0 },
  { value: 'checkName', label: '检查项目', rid: 3, pid: 0 },
];
